import React from 'react';
import './Job1.css';
import { Container } from 'react-bootstrap';
import Footer from './Footer';

const Job1 = () => {
    return (
        <>
        <div style={{textAlign:'justify'}}>
            <br/><br/>
            <Container>
            <h2>Graphic Design Internship Job Description</h2>
            <p>We are seeking a creative and enthusiastic graphic design intern to join our team. As a graphic design intern, you will have the opportunity to work on a variety of projects, including creating marketing materials, designing social media graphics, and assisting with website design.</p>

            <br/>
            <h3>Responsibilities:</h3>
            <ul>
                <li className='points_rem'>Assist in the creation of digital and print marketing materials</li>
                <li className='points_rem'>Design social media graphics, including banners and posts</li>
                <li className='points_rem'>Collaborate with the marketing team to develop creative concepts</li>
                <li className='points_rem'>Assist with website design and updates</li>
                <li className='points_rem'>Contribute ideas and concepts to team meetings</li>
            </ul>

            <br/>

            <h3>Requirements:</h3>
            <ul>
                <li className='points_rem'>Proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign)</li>
                <li className='points_rem'>Strong design skills and attention to detail</li>
                <li className='points_rem'>Ability to work independently and as part of a team</li>
                <li className='points_rem'>Excellent communication and time management skills</li>
            </ul>

            <br/>

            <h3>Perks:</h3>
            <ul>
                <li className='points_rem'>Opportunity to work on real-world projects and build your portfolio</li>
                <li className='points_rem'>Learn from experienced professionals in the field</li>
                <li className='points_rem'>Flexible hours to accommodate your schedule</li>
                <li className='points_rem'>Remote work</li>
                <li className='points_rem'>Certificate of completion provided upon successful internship completion</li>
                <li className='points_rem'>Stipend: Unpaid</li>
            </ul>
            <br/>

            <p>Send your Resume on <a href="mailto:quicklearn-rtu@gmail.com">email</a></p>
            </Container>

            <hr/>
            <Footer/>
        </div>
        </>
    );
}

export default Job1;
